import request from "@/utils/request.js";
export function list(params) {
    return request({
        url: '/v2/inspect/report/room',
        method: 'GET',
        params
    })
}

export function pushMail(params) {
    return request({
        url: '/v2/inspect/report/room/push/mail',
        method: 'GET',
        params
    })
}

export function list2(params, modulesUuid = 'device') {
    return request({
        url: '/v2/inspect/report/device',
        method: 'GET',
        params: { ...params, modulesUuid }
    })
}

export function pushMail2(params, modulesUuid = 'device') {
    return request({
        url: `/v2/inspect/report/${modulesUuid}/push/mail`,
        method: 'GET',
        params
    })
}
